<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <v-chip
      v-if="chip"
      v-bind="schema.attributes"
      :class="schema.styleClasses"
      :close="isClose"
      @click:close="chip = false"
    >
      <v-icon
        v-if="schema.attributesIcon && schema.attributesIcon.left"
        v-bind="schema.attributesIcon"
      >
        {{ schema.attributesIcon.icon }}
      </v-icon>
        {{ schema.name }}
      <v-icon
        v-if="schema.attributesIcon && schema.attributesIcon.right"
        v-bind="schema.attributesIcon"
      >
        {{ schema.attributesIcon.icon }}
      </v-icon>
    </v-chip>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  data: () => ({ chip: true }),
  props: {
    schema: { type: Object, default: () => ({}) }
  },

  computed: {
    isClose() {
      if(this.schema.attributes.close === undefined || this.schema.attributes.close === false) {
        return false
      } else {
        return true
      }
    },
    isValue() {
      if(this.schema.attributes.inputValue === undefined || this.schema.inputValue === false) {
        return false
      } else {
        return this.schema.attributes.inputValue
      }
    }
  },

  mixins: [abstractField, devComponentMixin],
  methods: {
    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    }
  }
}
</script>